import { Component } from '@angular/core';
import { LoaderService } from "../services/loader.service";
import { Observable } from "rxjs";
import { LanguageService } from '../services/language.service';
import { IconService } from '../services/icon.service';
import { UserRole } from '../common/models/user/user-role.enum';
import { inOutAnimation } from '../common/animations';
import { Router } from '@angular/router';
import { AccessibilityService } from '../services/accessibility.service';

@Component({
  selector: 'psc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [inOutAnimation({})],
})
export class AppComponent {
  title = 'PVSmartClick';

  loading$: Observable<boolean> = this.loaderService.loadingObservable;
  showLoadingText: boolean = false;
  showHeaderAndFooter: boolean;

  constructor(
    private loaderService: LoaderService,
    private languageService: LanguageService,
    private router: Router,
    private accessibilityService: AccessibilityService,
    iconService: IconService,
  ) {
    this.languageService.initLanguages();
    iconService.setCustomIcons();
    let timeout;
    this.loading$.subscribe((value) => {
      if (value) {
        timeout = setTimeout(() => {
          this.showLoadingText = true;
        }, 15000);
      } else {
        if (timeout) {
          clearTimeout(timeout);
        }
        this.showLoadingText = false;
      }
    });
  }

  onScrollToTopClick() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  modifyHeader() {
    this.showHeaderAndFooter = !this.router.url.startsWith('/calculator-frame');
  }

  protected readonly UserRole = UserRole;
}
